import {
  type IBrandGroup,
  pluckEntityStores,
} from "helpers/transforms/entities";

// The whole-merchant-group workspace: a synthetic IBrandGroup spanning every
// location across all brands. This is the DEFAULT scope for the Menu Management
// pages (formerly Group Management) — those pages operate merchant-group-wide, not
// per brand. Reconcile-by-name then unions across the entire MG. Reached at
// vendor level "g" with vendorLocation "all" (a specific custom group narrows
// to "g" with the group's slug).
export const MG_WORKSPACE_BRAND_ID = "mg";
export const MG_WORKSPACE_VENDOR_LOCATION = "all";
export const MG_WORKSPACE_LABEL = "All Locations";

export const isMerchantGroupWorkspaceId = (brandId: string): boolean =>
  brandId === MG_WORKSPACE_BRAND_ID;

export const buildMerchantGroupWorkspace = (
  brands: IBrandGroup[],
  label: string = MG_WORKSPACE_LABEL
): IBrandGroup => ({
  brand: label,
  brandId: MG_WORKSPACE_BRAND_ID,
  stores: pluckEntityStores(brands),
});
